import { Suspense } from "react";
import { Route, Routes as RouterRoutes } from "react-router";
import { lazyWithRetry } from "./lazyWithRetry";
import ProtectedRoutes from "./ProtectedRoutes";

const ChangePassword = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "ChangePassword" */
      "routes/Auth/ChangePassword/ChangePassword"
    )
);
const ForgotPassword = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "ForgotPassword" */
      "routes/Auth/ForgotPassword"
    )
);
const LoginForm = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "LoginForm" */
      "routes/Auth/Login/Login"
    )
);
const ChangePasswordNew = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "ChangePasswordNew" */
      "routes/AuthRedesign/ChangePassword/ChangePassword"
    )
);
const ForgotPasswordNew = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "ForgotPasswordNew" */
      "routes/AuthRedesign/ForgotPassword"
    )
);
const LoginFormNew = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "LoginFormNew" */
      "routes/AuthRedesign/Login/Login"
    )
);
const MaintenanceNew = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "MaintenanceNew" */
      "routes/AuthRedesign/Maintenance"
    )
);
const Unsubscribe = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "Unsubscribe" */
      "routes/Unsubscribe"
    )
);
const Maintenance = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "Maintenance" */
      "routes/Auth/Maintenance"
    )
);

function Routes() {
  return (
    <Suspense fallback={""}>
      <RouterRoutes>
        <Route
          path="/change-password"
          element={<ChangePassword />}
        />
        <Route
          path="/forgot-password/:email?"
          element={<ForgotPassword />}
        />
        <Route
          path="/login/"
          element={<LoginForm />}
        />
        <Route
          path="/unsubscribe/:subscriptionType"
          element={<Unsubscribe />}
        />
        <Route
          path="/maintenance"
          element={<Maintenance />}
        />
        {/* The redesigned screens (DPLAT-1729) ship alongside the old ones
            until product switches over - see routes/AuthRedesign/routes.ts */}
        <Route
          path="/change-password-new"
          element={<ChangePasswordNew />}
        />
        <Route
          path="/forgot-password-new/:email?"
          element={<ForgotPasswordNew />}
        />
        <Route
          path="/login-new"
          element={<LoginFormNew />}
        />
        <Route
          path="/maintenance-new"
          element={<MaintenanceNew />}
        />
        <Route
          path="*"
          element={<ProtectedRoutes />}
        />
      </RouterRoutes>
    </Suspense>
  );
}

export default Routes;
